module.exports = __webpack_public_path__ + "components/blogs-header/static/header--small@2x-2044f2d523a2cfb7e6c2f2494a38a9b3.jpg";